import { Upsell } from './Upsell';

// TODO: in v9, move styled() from Upsell.jsx to here
export var StyledUpsell = Upsell;